export default __webpack_public_path__ + "static/media/download_charcoal.1a971a39.svg";